const date = new Date();
const year = date.getFullYear();
const isPOS = window.location.href.toLowerCase().includes("karlstechnology");
const isFFLBoss = window.location.href.toLowerCase().includes("fflboss");
const isTactical = window.location.href.toLowerCase().includes("tactical");

const APPCONFIG = {
	brand: (() => {
		let title = isTactical ? "Tactical POS Admin" : 'FFL Boss POS Admin';
		document.title = title;
		return title;
	})(),
	year,
	reCAPTCHA: '6Lc83iYsAAAAAEGKGEjKEp5ywXrDyYfzkQef_6ms',
	copyright: '2018',
	productLink: 'https://pos.karlstechnology.com',
	settings: {
		isDev: () => {
			if(isPOS || isFFLBoss){
				return window.location.hostname === 'dev.admin.pos.karlstechnology.com' || window.location.hostname === 'beta.admin.pos.karlstechnology.com';
			} else if (isTactical){
				return window.location.hostname === 'dev.admin.tacticalpos.com' || window.location.hostname === 'beta.admin.tacticalpos.com';
			}
		},
		appURL: () => {
			return window.location.hostname === 'beta.admin.pos.karlstechnology.com' ? "https://beta.pos.karlstechnology.com" : (
				window.location.hostname === 'admin.pos.karlstechnology.com' ?
					'https://pos.karlstechnology.com' :
					'https://dev.pos.karlstechnology.com');
		},
		apiURL: () => {
				return window.location.hostname === 'beta.admin.pos.karlstechnology.com' ? "https://beta.api.pos.karlstechnology.com" : (
					window.location.hostname === 'dev.admin.pos.karlstechnology.com' ?
						'https://dev.api.pos.karlstechnology.com' :
						'https://api.pos.karlstechnology.com')
					;
		},
		fflBossURL: () => {
			if(isPOS) {
				return window.location.hostname === 'beta.admin.pos.karlstechnology.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.admin.karlstechnology.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			} else if (isTactical){
				return window.location.hostname === 'beta.admin.tacticalpos.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.admin.tacticalpos.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			} else if (isFFLBoss){
				return window.location.hostname === 'beta.admin.pos.fflboss.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.admin.fflboss.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			}
		},
		apiVersion: 'v378'
	}
};

export default APPCONFIG;
